import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { getMABAA080AdminRegisterBanner, postMABAA080RecruitExtraGoodReuse } from '../../../../services/Api';
import { formatDate, handleFocus } from '../../../../utils';
const PopupMABAA080_9 = ({ onClose, additionalData }) => {
    const { memberID, recruitSeq, goodCode, paySeq, recruitFrom, recruitEnd, extraSeq, extraTerm } = additionalData;
    const [popupDataComment, setPopupDataComment] = useState([]);
    const [popupDataCompanyName, setPopupDataCompanyName] = useState('');
    const [payload, setPayload] = useState({
        goodCode,
        recruitFrom,
        recruitEnd,
        memberID,
        paySeq,
        comment: '',
        statusFlag: 'N',
        extraFrom: extraTerm ? extraTerm.split('|')[1].trim() : '',
        extraEnd: extraTerm ? extraTerm.split('|')[2].trim() : '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const formatDatePayload = (date) => {
        if (date) {
            return moment(date).format('YYYY-MM-DD');
        } else {
            return;
        }
    };

    useEffect(() => {
        getMABAA080AdminRegisterBanner({
            params: {
                memberID,
                recruitSeq,
            },
        })
            .then(({ data }) => {
                setPopupDataComment(data.comments);
                setPopupDataCompanyName(data.companyName);
            })
            .catch((error) => console.log(error));
    }, [memberID, recruitSeq]);

    const handleSave = () => {
        if (!payload.extraFrom) {
            alert('강조 시작일을 선택해 주세요.');
            handleFocus('extraFrom');
            return;
        }
        const formattedExtraFrom = formatDatePayload(payload.extraFrom);
        const formattedRecruitFrom = formatDatePayload(payload.recruitFrom);

        if (formattedExtraFrom < formattedRecruitFrom) {
            alert('강조 시작일이 채용 시작일 이전입니다.강조 시작일을 확인하세요.');
            handleFocus('extraFrom');
            return;
        }

        if (!payload.extraEnd) {
            alert('강조 종료일을 선택해 주세요.');
            handleFocus('extraEnd');
            return;
        }

        const formattedExtraEnd = formatDatePayload(payload.extraEnd);
        const formattedRecruitEnd = formatDatePayload(payload.recruitEnd);

        if (formattedExtraEnd > formattedRecruitEnd) {
            alert('강조 종료일이 채용 종료일 이후입니다.강조 종료일을 확인하세요.');
            handleFocus('extraEnd');
            return;
        }

        if (formattedRecruitFrom > formattedRecruitEnd) {
            alert('채용 종료일이 채용 시작일 이전입니다.');
            handleFocus('recruitFrom');
            return;
        }

        const updatedPayload = {
            ...payload,
            memberID,
            recSeq: recruitSeq,
            extraTerm: `${payload.goodCode}|${formattedExtraFrom}|${formattedExtraEnd}`,
            orgExtraGoodNameCode: goodCode,
            chgExtraGoodNameCode: payload.goodCode,
            recruitFrom: formattedRecruitFrom,
            seq: extraSeq,
            recruitEnd: formattedRecruitEnd,
            extraFrom: formattedExtraFrom,
            extraEnd: formattedExtraEnd,
        };

        postMABAA080RecruitExtraGoodReuse(updatedPayload)
            .then(() => {
                alert('수정이 완료되었습니다.');
                onClose();
            })
            .catch((error) => console.log(error));
    };
    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="dental-information" className="dental-information dental-information_2">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={onClose} />
                        <div className="popup-header">[수정/마감]</div>
                        <div className="popup-title">[덴탈잡] 추가 강조상품 수정 및 마감</div>
                        <div className="table-dental-information MABAA080_8">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>아이디</td>
                                        <td>{memberID}</td>
                                    </tr>
                                    <tr>
                                        <td>치과명</td>
                                        <td>{popupDataCompanyName}</td>
                                    </tr>
                                    <tr>
                                        <td>채용일자</td>
                                        <td>
                                            <div
                                                className="flex group-item"
                                                style={{ justifyContent: 'center', alignItems: 'center' }}
                                            >
                                                <DatePicker
                                                    onChange={(date) =>
                                                        handleInputChange({
                                                            target: { name: 'recruitFrom', value: date },
                                                        })
                                                    }
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={payload.recruitFrom}
                                                    maxDate={payload.recruitEnd || null}
                                                    id="recruitFrom"
                                                />
                                                <span>~</span>
                                                <DatePicker
                                                    onChange={(date) =>
                                                        handleInputChange({
                                                            target: { name: 'recruitEnd', value: date },
                                                        })
                                                    }
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={payload.recruitEnd}
                                                    minDate={payload.recruitFrom || null}
                                                    id="recruitEnd"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>강조상품</td>
                                        <td>
                                            <div className="d-flex align-items-center px-2">
                                                <select
                                                    name="goodCode"
                                                    onChange={handleInputChange}
                                                    style={{ width: '250px' }}
                                                    value={payload.goodCode}
                                                >
                                                    <option value="000">상품구분</option>
                                                    <option value="3020">아이콘강조(HOT)</option>
                                                    <option value="3021">아이콘강조(HOT)(체험)</option>
                                                    <option value="3200">아이콘강조(HOT)(추가)</option>
                                                    <option value="3010">아이콘강조(주목)</option>
                                                    <option value="3011">아이콘강조(주목)(체험)</option>
                                                    <option value="3100">아이콘강조(주목)(추가)</option>
                                                    <option value="3520">아이콘강조2(HOT)</option>
                                                    <option value="3521">아이콘강조2(HOT)(체험)</option>
                                                    <option value="3529">아이콘강조2(HOT)(추가)</option>
                                                    <option value="3510">아이콘강조2(주목)</option>
                                                    <option value="3511">아이콘강조2(주목)(체험)</option>
                                                    <option value="3519">아이콘강조2(주목)(추가)</option>
                                                    <option value="2000">컬러강조</option>
                                                    <option value="2001">컬러강조(체험)</option>
                                                    <option value="2100">컬러강조(추가)</option>
                                                    <option value="2500">컬러강조2</option>
                                                    <option value="2501">컬러강조2(체험)</option>
                                                    <option value="2510">컬러강조2(추가)</option>
                                                    <option value="1000">하이라이트강조</option>
                                                    <option value="1001">하이라이트강조(체험)</option>
                                                    <option value="1100">하이라이트강조(추가)</option>
                                                    <option value="1500">하이라이트강조2</option>
                                                    <option value="1501">하이라이트강조2(체험)</option>
                                                    <option value="1510">하이라이트강조2(추가)</option>
                                                </select>
                                                <div className="d-flex align-items-center">
                                                    <DatePicker
                                                        onChange={(date) =>
                                                            handleInputChange({
                                                                target: { name: 'extraFrom', value: date },
                                                            })
                                                        }
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={payload.extraFrom}
                                                        maxDate={payload.extraEnd || null}
                                                        id="extraFrom"
                                                    />
                                                    <span>~</span>
                                                    <DatePicker
                                                        onChange={(date) =>
                                                            handleInputChange({
                                                                target: { name: 'extraEnd', value: date },
                                                            })
                                                        }
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={payload.extraEnd}
                                                        minDate={payload.extraFrom || null}
                                                        id="extraEnd"
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>사용여부</td>
                                        <td>
                                            <div>
                                                <select name="statusFlag" onChange={handleInputChange}>
                                                    <option value="N">사용</option>
                                                    <option value="C">마감</option>
                                                    <option value="D">삭제</option>
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Comment</td>
                                        <td colSpan={3}>
                                            <textarea name="comment" onChange={handleInputChange} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="note-table">
                            ※ Comment 등록형식 : [상품명]/ [Comment] . ex) 프리미엄배너 / 전화가 안와요 불만)
                        </div>
                        <div className="group-btn">
                            <button className="popup-button" onClick={handleSave}>
                                등록 / 수정
                            </button>
                        </div>
                        <div className="table-comment-results">
                            <div className="table-comment-results-title">
                                등록된 Comment (
                                {popupDataComment && popupDataComment.length > 0 ? popupDataComment.length : 0})
                            </div>
                            <table className="table-gray">
                                <thead>
                                    <tr>
                                        <th>Seq</th>
                                        <th>등록일</th>
                                        <th>관리자명</th>
                                        <th>등록사이트</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {popupDataComment && popupDataComment.length > 0 ? (
                                        popupDataComment.map((item) => (
                                            <tr key={item.seq}>
                                                <td>{item.seq}</td>
                                                <td>{formatDate(item.addDate)}</td>
                                                <td>{item.adminName}</td>
                                                <td>{item.sitePos}</td>
                                                <td>{item.comments}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">
                                                데이타가 없습니다.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PopupMABAA080_9;
